import Vue from "vue";
import { newLogger } from "@/utils/util";
import network from "../../../utils/network";

let logger = newLogger("PurchaseStore");

const urls = {
  myPurchases: `/credit/purchase/merchant/my-purchases`,
  myPurchasesWithQuery: (query) =>
    `/credit/purchase/merchant/my-purchases?${query}`,
  purchase: (id) => `/credit/purchase/merchant/${id}`,
};

const initState = () => {
  return {
    purchases: [],
    purchase: {},
  };
};

const actions = {
  fetchList: async ({ commit }, query) => {
    try {
      const axios = await network.connection();
      let url = urls.myPurchases;
      if (query) {
        url = urls.myPurchasesWithQuery(query);
      }
      let { data } = await axios.get(url);
      commit("savePurchases", data);
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
  fetch: async ({ commit }, id) => {
    try {
      const axios = await network.connection();
      let { data } = await axios.get(urls.purchase(id));
      commit("savePurchase", { data: data, id: id });
    } catch (err) {
      logger.error(err);
      await Promise.reject(err);
    }
  },
};

const mutations = {
  savePurchases: (state, data) => {
    Vue.set(state, "purchases", data);
  },
  savePurchase: (state, { data, id }) => {
    Vue.set(state.purchase, id, data);
  },
};

const getters = {
  getList: (state) => {
    return state.purchases;
  },
  get: (state) => (id) => {
    return state.purchase[id];
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
